import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, PLATFORM } from '@const'
import * as utils from '@utils'
import { Search } from '@material-ui/icons'
import { Grid, InputLabel, FormControl, Select, MenuItem, Button } from '@material-ui/core'
import { TextField } from '@prototype'
import Table from '@tables/table'
import { PfSubPfSelect, GameSelect, DatetimeSelect, CompleteDecimal } from '@select'
import clsx from 'clsx'
import { ComponentDialog } from '@dialogs'
import moment from 'moment'


const COMPONENT_GROUP = 'event_prize';
export const SEARCH_TYPE_DATE = 'date',
    SEARCH_TYPE_BET_SLIP = 'betSlip',
    SEARCH_TYPE_ROUND = 'round'

class EventPrizeDetailFreeGameDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventPrizeDetailFreeGameDialog', options)
        }
        this.state = {
            dateTimeMin: '',
            dateTimeMax: '',
            startAt: '',
            endAt: '',
            pfSubPfId: [],
            gameCode: [],
            betRecordID: '',
            roundID: '',
            eventID: '',
            currency: '',
            pfId: '',
            searchType: 'date',
            selectList: {
                SEARCH_TYPE_DATE: {
                    value: 'date',
                    label: 'date'
                },
                SEARCH_TYPE_BET_SLIP: {
                    value: 'betSlip',
                    label: 'betSlipNo'
                },
                SEARCH_TYPE_ROUND: {
                    value: 'round',
                    label: 'roundId'
                }
            },
            export: false,
            playGameCodeList: [],
            joinedSubPfList: []
        }
    }
    
    columns = [
        {
            field: 'round_end_at',
            type: 'datetime',
        },
        {
            field: 'bet_record_id',
            render: (rowData) => {
                return (
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault()

                            utils.apiRequest(
                                'get',
                                API.BET_DETAIL + '/' + rowData.bet_record_id,
                                {
                                    lang: utils.getCurrentLang(),
                                    'free_spin': true
                                },
                                (data) => {
                                    const currency = utils.getPfSubPfCurrency(rowData['pf_sub_pf_id'])
                                    const query = `&timezone=-0400&is_cms=yes&currency=${currency}&currency_rate=${1 /
                                        utils.getCurrencyRate(currency)}`

                                    window.open(data.url + query)
                                }
                            )
                        }}>
                        {rowData.bet_record_id}
                    </a>
                )
            },
        },
        {
            field: 'round_id',
            render: (rowData) => {
                return this.props.compDialogArgs?.isPrizePage ? <Button
                    className={this.props.classes.linkButton}
                    onClick={() => {
                        this.compDialog.OpenDialog(
                            utils.t('GameRoundResultPage', 'GameRoundResultPage'),
                            <SelfComponent
                                compDialogArgs={{
                                    searchType: this.state.selectList.SEARCH_TYPE_ROUND.value,
                                    roundID: rowData['round_id'],
                                    eventID: this.state.eventID
                                }}></SelfComponent>
                        )
                    }}>
                    {rowData['round_id']}
                </Button> : rowData['round_id']
            },
        },
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'pf_account',
        },
        {   
            field: 'origin_account'
        },
        {
            field: 'bet'
        },
        {
            field: 'bet_valid'
        },
        {
            field: 'profit',
            type: 'currency',
            render: (row, display) => {
                const fontColor = row['profit'] < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
        },
        {
            field: 'tax',
            type: 'currency',
        },
        {
            field: 'common_result',
            render: (rowData) => {
                if (utils.IsSupportSplitBetRecord(rowData.game_code)) {
                    if (this.roundResults[rowData.round_id]) {
                        const commonResult = JSON.parse(this.roundResults[rowData.round_id])
                        return utils.GetBetTypeGameCommonResultDisplay(rowData.game_code, commonResult)
                    } else {
                        return (
                            <a
                                href="/#"
                                onClick={(e) => {
                                    e.preventDefault()

                                    utils.apiRequest('get', API.BET_RECORD_LIST + '/round_result/' + rowData.round_id, {}, (data) => {
                                        this.roundResults[data.round_id] = data.common_result
                                        this.table.setDataDisplay()
                                    })
                                }}>
                                {this.t('showResults')}
                            </a>
                        )
                    }
                }

                return ''
            },
            cellStyle: { minWidth: '150px' },
        },
        {
            field: 'user_action_log',
            type: 'action',
            render: (rowData) =>
                utils.IsBetTypeGame(rowData.game_code) ? (
                    <Button
                        style={{ minWidth: '93px' }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.logDialog.OpenDialog({
                                game_code: rowData.game_code,
                                pf_account: rowData.pf_account,
                                round_id: rowData.round_id,
                                round_end_at: utils.datetimeToUnix(rowData.round_end_at),
                            })
                        }}>
                        {this.t('view')}
                    </Button>
                ) : (
                    ''
                ),
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.setState({
                export: true
            })
        }
        if (this.props.compDialogArgs) {
            if (this.props.compDialogArgs?.isPrizePage) {
                this.dateSelect.setState({
                    startDate: utils.unixToDateTime(this.props.compDialogArgs?.start_at),
                    endDate: utils.unixToDateTime(moment(this.props.compDialogArgs?.end_at).add(25, 'h')),
                })
                this.OpenDialog(this.props.compDialogArgs.eventID)
            } else {
                const state = {
                    searchType: this.props.compDialogArgs.searchType,
                    eventID: this.props.compDialogArgs.eventID,
                }

                switch (state.searchType) {
                    case SEARCH_TYPE_ROUND:
                        state.roundID = this.props.compDialogArgs.roundID
                        break
                    default:
                        return
                }
                this.setState(state, ()=>{
                    this.queryData()
                })
            }
        }
    }

    OpenDialog(eventID) {
        utils.apiRequest(
            'get',
            API.GIVE_FREE_GAME_DETAIL,
            {
                event_id: eventID,
            },
            (data) => {
                const {event_id, start_at, end_at, currency, play_game_code_list, joined_sub_pf_list} = data
                /** 預設搜尋結束時間為活動結束時間+25H */
                const limitEndAt = moment(end_at).add(25, 'h')
                let pfId = PLATFORM.PF_INFO.find(item => {
                    return item.currency === currency
                })?.pfID
                /** 平台為遊客 */
                if (joined_sub_pf_list[0].split('_')[0] === 'guest') {
                    pfId = 'guest'
                }
                this.setState({
                    searchType: 'date',
                    eventID: event_id,
                    pfId,
                    currency,
                    startAt: utils.unixToDateTime(start_at),
                    endAt: utils.unixToDateTime(limitEndAt),
                    playGameCodeList: play_game_code_list,
                    joinedSubPfList: joined_sub_pf_list
                }, () => {
                    setTimeout(() => {
                        this.dateSelect.setState({
                            startDate: utils.unixToDateTime(start_at),
                            endDate: utils.unixToDateTime(limitEndAt),
                        })
                        this.pfSelect.setState({
                            pfId: pfId
                        }, () => {
                            this.pfSelect.setSubPfList()
                        })
                    })
                })
                this.queryData({event_id, start_at, end_at: limitEndAt, pfId})
            },
            (_err) => {},
            true
        )
    }

    queryData(eventInfo) {
        this.freeGameTable.SetLoading(true)
        const params = {}
        let apiUrl = API.GIVE_FREE_GAME_DETAIL_list
        if (eventInfo) {
            const {event_id, start_at, end_at, pfId} = eventInfo
            params.event_id = event_id
            params.start_date = utils.datetimeToUnix(utils.unixToDateTime(start_at))
            params.end_date = utils.datetimeToUnix(utils.unixToDateTime(end_at))
            params.pf_id = pfId
            params.game_type = 2
        } else {
            params.event_id = this.state.eventID
            /** date */
            if (this.state.searchType === this.state.selectList.SEARCH_TYPE_DATE.value) {
                /** 開始時間大於結束時間 */
                if (moment(this.dateSelect.state.startDate).isAfter(this.dateSelect.state.endDate)) {
                    utils.addToast(this.t('DatePicker.invalidDateMessage'), 'error')
                    this.freeGameTable.SetLoading(false)
                    return false
                }
                params.start_date = utils.datetimeToUnix(this.dateSelect.state.startDate)
                params.end_date = utils.datetimeToUnix(this.dateSelect.state.endDate)
                params.pf_id = this.state.pfId
                params.game_type = 2
                /** 平台 */
                if (this.pfSelect.state.pfSubPfId !== 'all') {
                    params.pf_sub_pf_id = this.pfSelect.state.pfSubPfId
                }
                /** 遊戲 */
                if (this.gameSelect.state.gameCode !== 'all') {
                    params.game_code = this.gameSelect.state.gameCode
                }
                /** 搜尋條件暫存 */
                this.setState({
                    startAt: this.dateSelect.state.startDate,
                    endAt: this.dateSelect.state.endDate,
                    pfSubPfId: params.pf_sub_pf_id || [],
                    gameCode: params.game_code || [],
                })
            }
            /** betSlip */
            if (this.state.searchType === this.state.selectList.SEARCH_TYPE_BET_SLIP.value) {
                apiUrl = API.GIVE_FREE_GAME_DETAIL_record
                params.bet_record_id = this.state.betRecordID
            }
            /** round */
            if (this.state.searchType === this.state.selectList.SEARCH_TYPE_ROUND.value) {
                apiUrl = API.GIVE_FREE_GAME_DETAIL_round
                params.round_id = this.state.roundID
            }
        }
        utils.apiRequest(
            'get',
            apiUrl,
            params,
            (data) => {
                /** 注單查詢回應為物件格式, 統一轉換陣列格式 */
                const list = Array.isArray(data) ? data : [data]
                this.handleDataForm(list)
            },
            (_err) => {
                this.freeGameTable.SetLoading(false)
                this.freeGameTable.SetData([])
            },
            true
        )
    }

    handleDataForm(list) {
        let pfId = ''
        list.forEach((item, index) => {
            const decimal = this.props.auth.isCompleteDecimal ? 6 : 2
            const {bet, bet_valid, pf_id, record_id} = item
            list[index]['bet'] = `0 (${utils.currencyFormatter(bet, decimal, utils.getCurrencyRate(utils.getPfCurrency(pf_id)))})`
            list[index]['bet_valid'] = `0 (${utils.currencyFormatter(bet_valid, decimal, utils.getCurrencyRate(utils.getPfCurrency(pf_id)))})`
            list[index]['bet_record_id'] = record_id
            pfId = pf_id
        })
        this.freeGameTable.SetData(list, utils.getPfCurrency(pfId))
    }

    render() {
        const { selectList } = this.state
        return (
            <Grid container spacing={2}>
                {this.props.compDialogArgs?.isPrizePage && <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel htmlFor="age-simple">{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) => 
                                this.setState({
                                    searchType: event.target.value,
                                },()=>{
                                    /** 選擇日期搜尋時帶入最後搜尋條件 */
                                    if (event.target.value === this.state.selectList.SEARCH_TYPE_DATE.value) {
                                        this.dateSelect.setState({
                                            startDate: this.state.startAt,
                                            endDate: this.state.endAt,
                                        })
                                        this.pfSelect.setState({
                                            pfId: this.state.pfId,
                                            pfSubPfId: this.state.pfSubPfId
                                        }, () => {
                                            const needCheckPfSubPfId = Boolean(this.state.pfSubPfId.length)
                                            this.pfSelect.setSubPfList(needCheckPfSubPfId)
                                        })
                                        if (this.state.gameCode.length) {
                                            this.gameSelect.setState({
                                                gameCode: this.state.gameCode
                                            })
                                        }
                                    }
                                })
                            }>
                            {
                                Object.values(selectList).map((item) => {
                                    return <MenuItem key={item.value} value={item.value}>{this.t(`${item.label}`)}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                    {this.state.searchType === selectList.SEARCH_TYPE_DATE.value && (
                        <>
                            <DatetimeSelect
                                onRef={(ref) => (this.dateSelect = ref)}
                            />
                            <TextField
                                className={clsx(this.props.classes.textField, this.props.classes.readonlyTextField)}
                                readOnly
                                label={this.t('gameType')}
                                value={this.t('GameType.2')}
                            />
                            <GameSelect
                                onRef={(ref) => (this.gameSelect = ref)}
                                options={{
                                    hideGameTypeSelect: true,
                                    gameOpenedList: this.state.playGameCodeList,
                                    gameListFilter: (gameInfo) => {
                                        return gameInfo['display_game_type_code_id'] === '2'
                                    }
                                }}
                            />
                            <TextField
                                className={clsx(this.props.classes.textField, this.props.classes.readonlyTextField)}
                                readOnly
                                label={this.t('currency')}
                                value={this.state.currency ? this.t(`Currency.${this.state.currency}`) : ''}
                            />
                            <PfSubPfSelect
                                onRef={(ref) => (this.pfSelect = ref)}
                                options={{
                                    hidePlatform: true,
                                    openSubPfList: this.state.joinedSubPfList
                                }}
                            />
                        </>
                    )}
                    {this.state.searchType === selectList.SEARCH_TYPE_BET_SLIP.value && (<TextField
                        label={this.t('betSlipNo')}
                        placeholder={this.t('enterNoEntirely')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.betRecordID}
                        onChange={(event) =>
                            this.setState({
                                betRecordID: event.target.value,
                            })
                        }
                        className={this.props.classes.textField}
                    />)}
                    {this.state.searchType === selectList.SEARCH_TYPE_ROUND.value && (<TextField
                        label={this.t('roundId')}
                        placeholder={this.t('enterNoEntirely')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.roundID}
                        onChange={(event) =>
                            this.setState({
                                roundID: event.target.value,
                            })
                        }
                        className={this.props.classes.textField}
                    />)}
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                    <CompleteDecimal />
                </Grid>}
                <Grid item xs={12}>
                    <Table
                        ownerName="EventPrizeDetailFreeGameDialog"
                        columns={this.columns}
                        options={{ export: this.state.export, orderDirection: 'desc' }}
                        onRef={(ref) => (this.freeGameTable = ref)}
                    />
                </Grid>
                <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        select: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
            '& input': {
                paddingTop: 6
            }
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        dateRangeTextField: {
            margin: theme.spacing(1),
            width: '360px',
        },
        readonlyTextField: {
            marginTop: 15,
            '& input': {
                paddingTop: 10.5
            }
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
        }
    }
}

EventPrizeDetailFreeGameDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    auth: PropTypes.object,
    compDialogArgs: PropTypes.object
}

const SelfComponent = hoc(styles)(EventPrizeDetailFreeGameDialog)
export default SelfComponent
